import { render, staticRenderFns } from "./payment-page-navigation.vue?vue&type=template&id=e1980c6c&scoped=true"
import script from "./payment-page-navigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./payment-page-navigation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./payment-page-navigation.vue?vue&type=style&index=0&id=e1980c6c&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1980c6c",
  null
  
)

export default component.exports